var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-page"},[_c('a-spin',{attrs:{"tip":"正在授权登陆中..."}},[_c('a-icon',{staticStyle:{"font-size":"24px"},attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }